export const UPLOAD_JSON_FILES = "UPLOAD_JSON_FILES";
export const INVALID_FILES_ERROR = "INVALID_FILES_ERROR";
